import {
  Box,
  Button,
  Header,
  Heading,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody
} from 'grommet'
import React from 'react'
import { SuspenseWithPerf, useFirebaseApp, useFirestoreDoc } from 'reactfire'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import {
  areas,
  businessValue,
  location,
  quality,
  accountPreferences
} from '../../utils/emptyProperty'
import { flattenObject, prettyTitle } from '../../utils/utils'
import Preferences from './Preferences'
import './Onboarding.css'

const Onboarding = (props) => {
  const firebaseApp = useFirebaseApp()
  const preferencesRef = firebaseApp
    .firestore()
    .collection(props.userID)
    .doc('preferences')
  const preferencesDoc = useFirestoreDoc(preferencesRef)
  const preferencesObject = preferencesDoc.data()
  const preferences = flattenObject(preferencesObject)

  if (!preferencesObject) {
    preferencesRef.set(accountPreferences)
  }

  const preferencesKeys = Object.keys(preferencesObject)
  if (!preferencesKeys.includes('Areas')) {
    preferencesRef.update(accountPreferences)
  }

  const MySwal = withReactContent(Swal)

  const setupPreferences = (user) =>
    MySwal.mixin({
      confirmButtonText: 'Next &rarr;',
      showCancelButton: true,
      showClass: {
        popup: 'none',
        backdrop: 'swal2-backdrop-show',
        icon: 'swal2-icon-show'
      },
      backdrop: true,
      allowOutsideClick: false,
      scrollbarPadding: false,
      position: 'top-start',
      customClass: {
        container: 'account-setup-container'
      },
      progressSteps: ['1', '2', '3', '4', '5']
    })
      .queue([
        {
          title: 'Maximum Price',
          text: 'How much would you pay if you found the place of your dreams?',
          footer: 'Account Preferences Setup',
          icon: 'question',
          input: 'number',
          inputValue: preferencesObject.maxPrice.toString() || '2_500_000',
          inputValidator: (value) => {
            if (!value || value <= 500000) {
              return 'Set a price bigger than 500 000kr'
            }
          }
        },
        {
          title: 'What are your preferences when it comes to areas in your dream home?',
          icon: 'question',
          html: (
            <Preferences preferences={areas} group="Areas" key="Areas" userID={user} />
          ),
          footer: 'Account Preferences Setup'
        },
        {
          title: 'How do you value the long-term investment of owning a place?',
          icon: 'question',
          html: (
            <Preferences
              preferences={businessValue}
              group="Business Value"
              key="Business Value"
              userID={user}
            />
          ),
          footer: 'Account Preferences Setup'
        },
        {
          title: 'Thinking about the location and premisses, what are your preferences?',
          icon: 'question',
          html: (
            <Preferences
              preferences={location}
              group="Location"
              key="Location"
              userID={user}
            />
          ),
          footer: 'Account Preferences Setup'
        },
        {
          title:
            'About the very details of the place, how do you like the quality these provide?',
          icon: 'question',
          html: (
            <Preferences
              preferences={quality}
              group="Quality"
              key="Quality"
              userID={user}
            />
          ),
          footer: 'Account Preferences Setup'
        }
      ])
      .then(async (result) => {
        if (result.value) {
          const maxPrice = Number(result.value[0])
          setTimeout(() => {
            preferencesRef.update({ maxPrice })
          }, 3000)

          MySwal.fire({
            title: 'All done!',
            icon: 'success',
            html: `Your preferences were saved successfully!`,
            confirmButtonText: 'Lovely!'
          })
        }
      })

  return (
    <SuspenseWithPerf fallback={<p>Loading Preferences</p>} traceId={'onboarding'}>
      <Header background="brand" pad="medium">
        <Heading style={{ fontSize: '3rem', textAlign: 'center', width: '100%' }}>
          Set your preferences
        </Heading>
      </Header>

      <Button
        label="Update Preferences"
        style={{
          backgroundColor: 'white',
          margin: '50px auto 20px auto',
          display: 'block'
        }}
        onClick={() => setupPreferences(props.userID)}
      />
      <Box pad={{ vertical: 'large', horizontal: 'medium' }}>
        <Heading level={2} backgroundColor="brand">
          Current Preferences
        </Heading>
        <Table>
          <TableHeader>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Name
              </TableCell>
              <TableCell scope="col" border="bottom">
                Preference
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Object.keys(preferences).map((preference) => (
              <TableRow key={preference}>
                <TableCell scope="row">
                  <strong>{prettyTitle(preference)}</strong>
                </TableCell>
                <TableCell>{preferences[preference]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </SuspenseWithPerf>
  )
}
export default Onboarding
